var _rect, _g, _rect2, _g2, _path, _line, _path2, _line2, _path3, _path4, _ellipse, _path5, _path6, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControlCmdElbowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 43,
    viewBox: "0 0 40 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2018_4244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 24,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.1992,
    y: 24.4932,
    width: 18.0073,
    height: 18.0073,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2018_4244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3556 33.9845H22.1758V33.0091H30.3556L26.5131 29.1666L27.2028 28.4697L32.2298 33.4968L27.2028 38.5238L26.5131 37.8269L30.3556 33.9845Z",
    fill: "#4ED064"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2018_4244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 24,
    width: 19,
    height: 19
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18.0073,
    height: 18.0073,
    transform: "matrix(-1 0 0 1 21.8008 24.4932)",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2018_4244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.64441 33.9845H17.8242V33.0091H9.64441L13.4869 29.1666L12.7972 28.4697L7.77016 33.4968L12.7972 38.5238L13.4869 37.8269L9.64441 33.9845Z",
    fill: "#4ED064"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91016 16.1051L14.092 4.5127M15.501 6.38527L12.7283 16.1051",
    stroke: "#DFD8D0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 8.16116,
    y2: -0.5,
    transform: "matrix(0.933352 0.358961 -0.371169 0.928565 20.0859 4.06641)",
    stroke: "#DFD8D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5.89453L26.8907 9.02994",
    stroke: "#DFD8D0"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 7.15243,
    y2: -0.5,
    transform: "matrix(-0.371169 0.928565 -0.933352 -0.358961 28.6992 4.50586)",
    stroke: "#DFD8D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2106 6.95202L33.0977 5.71868L36.251 10.0443",
    stroke: "#DFD8D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4613 8.81947L30.1914 12.9823L35.5017 11.9118",
    stroke: "#DFD8D0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 3.44268,
    rx: 3,
    ry: 2.94268,
    stroke: "#4ED064"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77637 17.0079C4.86594 16.5359 5.27845 16.1943 5.75884 16.1943H13.2412C13.7215 16.1943 14.1341 16.5359 14.2236 17.0079L15 21.0988H4L4.77637 17.0079Z",
    stroke: "#DFD8D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 25.0222L3 22.0986C3 21.5463 3.44772 21.0986 4 21.0986L15 21.0986C15.5523 21.0986 16 21.5463 16 22.0986L16 25.0222",
    stroke: "#DFD8D0"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 24.9678,
    x2: 40,
    y2: 24.9678,
    stroke: "#DFD8D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlCmdElbowIcon);
export default __webpack_public_path__ + "static/media/control-cmd-elbow-icon.f9570f36d298255ed15ceb5fc1ae9063.svg";
export { ForwardRef as ReactComponent };